import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Dropzone from 'react-dropzone'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import { MAX_SCAN_FILE_SIZE } from '../../state/file-upload/const'
import { formatDateTime } from '../../../../util/datetime'
import { BACKEND_URL } from '../../../../util/api'
import BlockUi from 'react-block-ui'
import * as names from '../../state/const'
import { FILE_TYPE_PRODUCTION } from '../../state/const'
import currentUserHasAccess from '../../../../util/widget-helper'
import * as availableTaskNames from '../../../process/ui-definition/sales-order/set-and-shop-scan/task-name'
import { sortProductionFilesByName } from '../../util/upload-helper'

const style = {
    width: '100%',
    height: '200px',
    borderWidth: '2px',
    borderColor: 'rgb(102, 102, 102)',
    borderStyle: 'dashed',
    borderRadius: '5px',
    padding: '35px',
    textAlign: 'center',
    cursor: 'pointer',
    marginTop: '32px',
}

const VIEW_URL = BACKEND_URL + '/api/file-system/view-file?fileId='
const DOWNLOAD_URL = BACKEND_URL + '/api/file-system/download-file?fileId='

const PRODUCTION_FILE_DOWNLOAD_ALL_URL = BACKEND_URL + '/api/production/download-production-files?customerId='

const HEADER_NAME_LIST = {
    [names.FILE_TYPE_IMAGE]: 'Customer Images',
    [names.FILE_TYPE_X_RAY]: 'X Ray Files',
    [names.FILE_TYPE_SCAN_FILE]: 'Scan Files',
    [names.FILE_TYPE_IMPLANT_SCAN_FILE]: 'Implant Scan Files',
    [names.FILE_TYPE_TREATMENT_PLAN]: 'Treatment Plan Files',
    [names.FILE_TYPE_TREATMENT_PLAN_EXTERNAL]: 'Treatment Plan External Files',
    [names.FILE_TYPE_PRODUCTION]: 'Production Files',
    [names.FILE_TYPE_CONFORMITY_DECLARATION]: 'Conformity declaration(s)',
    [names.FILE_TYPE_CUSTOMS_INVOICE]: 'Customs Invoice',
    [names.FILE_TYPE_IMPLANT_TREATMENT_PLAN]: 'Implant Treatment Plan',
    [names.FILE_TYPE_OTHER_FILES]: 'Other Files',
}


const UploadedFileTable = ({ fileList, fileType, readOnly, setDeleteFlag, onFileDeleteFlagSuccess }) => {
    if (!fileList) {
        return null
    }

    if (fileType === names.FILE_TYPE_PRODUCTION) {
        fileList.sort(sortProductionFilesByName)
    }

    return (
        <table className="default-table">
            <thead>
                <tr>
                    <th>File name</th>
                    <th>Uploaded</th>
                    <th>Download</th>
                    <th>View</th>
                    <th>Uploaded by</th>
                    <th>Delete</th>
                </tr>
            </thead>
            <tbody>
                {fileList.map(file => {
                    if (file.deleted) {
                        return null
                    }
                    return (
                        <tr key={file.id}>
                            <td>{file.fileName}</td>
                            <td>{formatDateTime(file.created)}</td>
                            <td><a href={DOWNLOAD_URL + file.id}>download</a></td>
                            <td><a href={VIEW_URL + file.id} target="_blank" rel="noopener noreferrer">view</a></td>
                            <td>{file.createdByUser}</td>
                            <td>
                                <button
                                    onClick={() => {
                                        setDeleteFlag(fileType, file.id, onFileDeleteFlagSuccess)
                                    }}
                                    disabled={readOnly}
                                    className="btn btn-primary btn-sm">delete
                                </button>
                            </td>
                        </tr>
                    )
                })}

            </tbody>
        </table>)
}


const CustomerFileUpload = ({ widgetId = null, customer, fileType, uploadCustomerFile, onUploadSuccess, setDeleteFlag, onFileDeleteFlagSuccess, fetching, readOnly, triggerVisualization, visualizationRequested, taskName }) => {
    if (widgetId && !currentUserHasAccess(widgetId)) {
        return null
    }

    if (!customer) {
        return null
    }
    const fileList = customer[fileType]
    const isTriggerButtonShown = (taskName === availableTaskNames.UPLOAD_TREATMENT_PLAN_FILES) ? 'none' : 'block'

    let displayedFileCount = ''
    if (fileType === FILE_TYPE_PRODUCTION) {
        const nonDeletedFileCount = fileList.filter((obj) => obj.deleted === false).length
        if (nonDeletedFileCount !== 0) displayedFileCount = '(' + nonDeletedFileCount + ')'
    }

    return (
        <BlockUi tag="div" blocking={fetching}>
            <ContentBox title={HEADER_NAME_LIST[fileType] + ' ' + displayedFileCount}>
                {triggerVisualization && !visualizationRequested && (
                    <Row>
                        <Column size={12}>
                            <button
                                onClick={() => {
                                    triggerVisualization(customer.id)
                                }}
                                disabled={readOnly}
                                style={{ display: isTriggerButtonShown }}
                                className="btn btn-primary btn-sm">trigger Visualization
                            </button>
                        </Column>
                    </Row>
                )}
                {
                    fileType === FILE_TYPE_PRODUCTION && fileList.length !== 0 && (
                        <Row>
                            <Column size={12}>
                                <a href={PRODUCTION_FILE_DOWNLOAD_ALL_URL + customer.id} className="btn btn-primary btn-sm" target="_blank" rel="noopener noreferrer">Download all <i className="fa fa-cloud-download"/></a>
                            </Column>
                        </Row>
                    )
                }
                <Row>
                    <Column>
                        <UploadedFileTable
                            onFileDeleteFlagSuccess={onFileDeleteFlagSuccess}
                            readOnly={readOnly}
                            setDeleteFlag={setDeleteFlag}
                            fileType={fileType}
                            fileList={fileList}/>
                    </Column>
                </Row>
                {uploadCustomerFile !== undefined && (<Row>
                    <Column size={12}>
                        <Dropzone
                            multiple={true}
                            maxSize={MAX_SCAN_FILE_SIZE}
                            style={style}
                            disablePreview={true}
                            onDrop={(fileList) => {
                                uploadCustomerFile(fileList, customer.id, fileType, onUploadSuccess)
                            }}>
                            <p>Click to upload a file</p>
                        </Dropzone>
                    </Column>
                </Row>)}
            </ContentBox>
        </BlockUi>
    )
}

CustomerFileUpload.propTypes = {
    widgetId: PropTypes.string,
    customer: PropTypes.object,
    fileType: PropTypes.string.isRequired,
    uploadCustomerFile: PropTypes.func,
    onUploadSuccess: PropTypes.func.isRequired,
    setDeleteFlag: PropTypes.func.isRequired,
    onFileDeleteFlagSuccess: PropTypes.func.isRequired,
    fetching: PropTypes.bool.isRequired,
    readOnly: PropTypes.bool,
    triggerVisualization: PropTypes.func,
    visualizationRequested: PropTypes.bool,
    taskName: PropTypes.string,
}

export default CustomerFileUpload



// WEBPACK FOOTER //
// ./src/modules/customer/component/scan-file-upload/CustomerFileUpload.js